import clsx from 'clsx';

/** Флаг-строка из макета: квадрат 18px с рамкой и галкой + подпись. */
export function RFlagCheckbox({
  checked,
  onChange,
  label,
  disabled,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={clsx(
        'flex items-center gap-[10px] text-left',
        disabled && 'cursor-not-allowed opacity-50'
      )}
    >
      <span
        className="flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-[5px] border-[1.5px]"
        style={{
          borderColor: checked ? '#3B4D7F' : 'rgba(46,58,94,0.22)',
          background: checked ? '#3B4D7F' : '#FFFFFF',
        }}
      >
        <svg width="11" height="11" viewBox="0 0 16 16" fill="none" aria-hidden>
          <path
            d="M3.6 8.4l3 3 5.8-6.6"
            stroke={checked ? '#FFFFFF' : 'transparent'}
            strokeWidth={2.4}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span
        className="whitespace-nowrap text-[12px]"
        style={{ color: checked ? '#141E31' : 'rgba(20,30,49,0.55)' }}
      >
        {label}
      </span>
    </button>
  );
}
